export default __webpack_public_path__ + "static/rubic-02b65331c9f51ff2386be1bbb58fe6d7.svg";